export default __webpack_public_path__ + "static/media/rms_banner.f5798e6e.jpg";